/* eslint-disable */
// Loads LL_DATA from backend (/api/site) and sets window.LL_DATA before
// rendering children. Also exposes:
//   window.LL_API.saveSite(data, token) — PUT entire site doc (admin).
//   window.LL_API.resetSite(token)      — restore defaults.
// Falls back to /ll_data.json if the API is unreachable.

import React, { useState, useEffect } from 'react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

async function fetchSiteFromApi() {
  const r = await fetch(`${API}/site`, { cache: 'no-cache' });
  if (!r.ok) throw new Error(`GET /api/site → ${r.status}`);
  return r.json();
}

async function fetchSiteFromStatic() {
  const r = await fetch('/ll_data.json', { cache: 'no-cache' });
  if (!r.ok) throw new Error(`GET /ll_data.json → ${r.status}`);
  return r.json();
}

async function saveSite(data, token) {
  const r = await fetch(`${API}/site`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(data),
  });
  if (!r.ok) throw new Error(`PUT /api/site → ${r.status}`);
  return r.json();
}

async function resetSite(token) {
  const r = await fetch(`${API}/site/reset`, {
    method: 'POST',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
  if (!r.ok) throw new Error(`POST /api/site/reset → ${r.status}`);
  return r.json();
}

if (typeof window !== 'undefined') {
  window.LL_API = { saveSite, resetSite, API };
}

export default function LarinzDataProvider({ children, fallback = null }) {
  const [ready, setReady] = useState(typeof window !== 'undefined' && window.LL_DATA);
  const [, force] = useState(0);

  useEffect(() => {
    if (ready) return;
    (async () => {
      let data;
      try { data = await fetchSiteFromApi(); }
      catch (e) {
        console.warn('Falling back to /ll_data.json:', e.message);
        data = await fetchSiteFromStatic();
      }
      window.LL_DATA = data;
      setReady(true);
    })();
  }, [ready]);

  useEffect(() => {
    const h = () => force(t => t + 1);
    window.addEventListener('ll-data-changed', h);
    return () => window.removeEventListener('ll-data-changed', h);
  }, []);

  // Apply theme variables to :root.
  useEffect(() => {
    if (!ready) return;
    const t = (window.LL_DATA && window.LL_DATA.theme) || {};
    const r = document.documentElement;
    r.style.setProperty('--ll-accent',      t.accent      || '#A5FF12');
    r.style.setProperty('--ll-accent-text', t.accentText  || '#111111');
    r.style.setProperty('--ll-dark',        t.dark        || '#0D0D0D');
    r.style.setProperty('--ll-light',       t.light       || '#F4F4F0');
    r.style.setProperty('--ll-text',        t.text        || '#111111');
    r.style.setProperty('--ll-muted',       t.muted       || '#888888');
    r.style.setProperty('--ll-border',      t.border      || '#EAEAE6');
  }, [ready]);

  if (!ready) return fallback;
  return children;
}
